import { Flex } from "@chakra-ui/react";

// Renders an empty Flex: the inherited template's footer links were stripped and
// nothing replaced them. It survives only because the padding below still shapes
// the admin layout's bottom spacing. Deleting it is a layout change, not a
// cleanup.
export default function Footer() {
  return (
    <Flex
      zIndex="3"
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent="space-between"
      px={{ base: "30px", md: "50px" }}
      pb="30px"
    ></Flex>
  );
}
